<template lang="pug">
#lista-area-monitorada
    .reorganizarMapaTabela
        | {{ $t('mensagens.monitoramentoAgricola.reorganizarMapaTabela') }}
        span.reorganizarMapaTabela--reorganizar-icon(
            @click='organizarLayout',
            :class='[larguraTotal ? "rotate" : ""]'
        )
            i.lyra-icon.lyra-pontos

    .lista-area-monitorada__container(
        :class='[larguraTotal ? "isOrganizarWidth" : ""]',
        v-loading='carregando'
    )
        .lista-area-monitorada__tabela
            h3 {{ $t('mensagens.monitoramentoAgricola.listagemTerritoriosEmMonitoramento') }}
            .tabela
                TabelaListarTerritorioMonitoramento(
                    v-if='paginaAreasMonitoradas !== {}',
                    :paginaAreasMonitoradas='paginaAreasMonitoradas',
                    :paginacao='paginacao',
                    :larguraTotal='larguraTotal',
                    :key='keyLista',
                    @ordenar='ordenar',
                    @mudarPagina='mudarPagina'
                )

        .lista-area-monitorada__mapa
            mapa(
                height='100%',
                idMapa='MapaListagemMonitoramentoSocioambiental',
                :key='keyMapa',
                :mapLayersConfigs='camadasMapa',
                :mapConfig='configuracoesMapa',
                :atualizarMapa='true'
            )
</template>

<script>
import L from 'leaflet';
import Mapa from '@/components/MapaLeaflet';
import TabelaListarTerritorioMonitoramento from '@/components/monitoramento/TabelaListarTerritorioMonitoramento';
import AreasMonitoradasService from '@/services/AreasMonitoradasService';

export default {
    name: 'ListaAreaMonitoradaSocioambiental',

    components: {
        Mapa,
        TabelaListarTerritorioMonitoramento
    },

    props: {
        filtros: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            camadasMapa: [],
            configuracoesMapa: {
                controls: {
                    zoomControl: false,
                    camadasControl: true,
                    fullscreen: true,
                    uploadFileControl: false,
                    marcarPontoControl: false,
                    botaoAnotacoes: false,
                    buscarAreaPorCoordenadasControl: false,
                    ferramentasControl: false
                }
            },
            larguraTotal: false,
            keyMapa: 1,
            keyLista: 10,
            paginaAreasMonitoradas: {},
            paginacao: {
                tamanho: 15,
                pagina: 0,
                ordenacao: 't.nome'
            },
            carregando: true
        };
    },

    watch: {
        filtros() {
            this.paginacao.pagina = 0;
            this.filtrarAreasMonitoradas();
        }
    },

    async created() {
        await this.filtrarAreasMonitoradas();
    },

    methods: {
        organizarLayout: function () {
            this.keyMapa++;
            this.keyLista++;
            this.larguraTotal = !this.larguraTotal;
        },

        async filtrarAreasMonitoradas() {
            try {
                this.carregando = true;
                const { data } =
                    await AreasMonitoradasService.buscarAreasMonitoradasSocioambiental(
                        this.filtros,
                        this.paginacao
                    );

                this.paginaAreasMonitoradas = data;
                await this.atualizarMapa();
            } catch {
                this.$notify.error({
                    message: this.$t(
                        'mensagens.monitoramentoAgricola.erros.filtrarAreasMonitoradas'
                    )
                });
            } finally {
                this.carregando = false;
            }
        },

        ordenar(ordenacao) {
            this.paginacao.ordenacao = ordenacao;
            this.filtrarAreasMonitoradas();
        },

        mudarPagina(novaPagina) {
            this.paginacao.pagina = novaPagina;
            this.filtrarAreasMonitoradas();
            this.$emit('buscarTotalizadores');
        },

        atualizarMapa() {
            this.camadasMapa = [];
            const camadasMapa = [];
            this.paginaAreasMonitoradas.resultados.forEach(
                ({ id, territorio }) => {
                    camadasMapa.push({
                        name: 'areaMonitorada_' + id,
                        icon: L.icon({
                            iconUrl:
                                'https://lyra-v1.s3.amazonaws.com/marker-icon.png',
                            iconSize: [18, 26]
                        }),
                        geoJson: territorio.centroide,
                        popup: this.criarPopup(id, territorio)
                    });
                }
            );
            this.camadasMapa = camadasMapa;
        },

        criarPopup(id, { nome, localidade }) {
            return `
				<h3>Território:</h3>
				<h4>${nome}</h4>
				<br>
				<h3>Localidade:</h3>
				<h4>${localidade}</h4>
                <br>
                <div id="btnVisualizar" class="btn-visualizar" onclick="window.location.replace('#/monitoramento/socioambiental/${id}', '_blank'); window.location.reload()">
					<span>Visualizar</span>
				</div>
                <style>
                    #btnVisualizar {
                        background-color: var(--primary);
                        border-color: var(--primary);
                        color: var(--white);
                    }

                    #btnVisualizar:hover,
                    #btnVisualizar:focus {
                        background-color: var(--secondary);
                        border-color: var(--secondary);
                        color: var(--color-button-hover);
                        outline: 0px auto var(--secondary);
                    }
                </style>
			`;
        }
    }
};
</script>

<style lang="scss" scoped>
#lista-area-monitorada {
    .reorganizarMapaTabela {
        font-size: 16px;
        margin-bottom: 16px;
        font-weight: 500;
        display: flex;
        justify-content: flex-end;
        align-items: center;

        .reorganizarMapaTabela--reorganizar-icon {
            padding: 10px;
            padding-bottom: 3px;
            background: var(--white);
            box-shadow: 0px 1px 7px 0px var(--block-shadow);
            border-radius: 5px;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-left: 10px;
            cursor: pointer;

            i::before {
                width: 7px !important;
                height: 23px !important;
                background: #3b3b3b;
            }
            &.rotate {
                i::before {
                    transform: rotate(90deg);
                }
            }
        }
    }
    .lista-area-monitorada__container {
        display: flex;
        flex-wrap: wrap;
        height: calc(100vh - 255px);
        .lista-area-monitorada__tabela {
            width: 59%;

            .tabela {
                padding-top: 0px;
                padding-bottom: 10px;
                margin-right: 10px;
                width: calc(100% - 10px);
            }
        }
        .lista-area-monitorada__mapa {
            width: 41%;
            height: 633px;
            border-radius: 5px;
            overflow: hidden;
            box-shadow: 0px 1px 5px 0px var(--block-shadow);
            margin-bottom: 14px;
            #mapa-listagem-territorio {
                border-radius: 6px;
            }
        }

        &.isOrganizarWidth {
            .lista-area-monitorada__tabela,
            .lista-area-monitorada__mapa {
                width: 100% !important;
            }
            .lista-area-monitorada__mapa {
                order: 1;
            }
            .lista-area-monitorada__tabela {
                order: 2;
                h3 {
                    margin-top: 12px !important;
                }
                .tabela {
                    margin-right: 0px !important;
                }
            }
        }
    }
    h3 {
        margin-bottom: 10px;
        margin-top: -30px;
        color: var(--var(--black));
        font-weight: 500;
    }
    .dimensao-mapa {
        height: 100% !important;
    }
}
</style>
